import Vue from 'vue';
import Router from 'vue-router';


import Home from '@/view/HomePage.vue';
import ContactUs from '@/components/ContactUs.vue';
import SolutionPage from '@/components/SolutionPage.vue';
import BuildingControl from '@/components/BuildingControl.vue';
import CompanyPage from '@/components/CompanyPage.vue';
import ProjectCase from '@/components/ProjectCase.vue';
import ProductPage from '@/components/ProuductPage.vue'

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/contact',
          name:'ContactUs',
          component: ContactUs
        },
        {
          path:'/solutionPage',
          name: 'SolutionPage',
          component: SolutionPage
        },
        {
          path:'/buildingControl',
          name: 'BuildingControl',
          component: BuildingControl
        },
        {
          path:'/companyPage',
          name: 'CompanyPage',
          component: CompanyPage
        },
        {
          path:'/projectCase',
          name: 'ProjectCase',
          component: ProjectCase
        },
        {
          path: '/productPage',
          name:'ProductPage',
          component: ProductPage
        }
    ]
})